<template>
  <div class="definition">
<!--    <div class="left">«</div>-->
    <div>
      <span class="for"><slot name="for" /></span> – <slot/>
    </div>
<!--    <div class="right">»</div>-->
  </div>
</template>

<script>
export default {
  name: "Definition"
}
</script>

<style lang="scss" scoped>
.definition {
  //margin-left: 32px;
  margin-top: 24px;
  background: #eed9ce;
  padding: 16px;
  display: flex;
  font-size: small;
  color: #52192e;

  .left, .right {
    //padding: 0 8px;
    flex-grow: 0;
  }
  .right {
    vertical-align: bottom;
    display: table-cell;
  }
}
.for {
  font-weight: bold;
}
</style>